import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { Button } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'
import { getStampDutyOptions } from 'ducks/options'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { RFQContainer } from 'routes/ProcurementSystem/RequestForQuotation/styled'
import ApproversE from 'routes/ProcurementSystem/PurchaseRequisition/Create/Summary/Approvers'

const RequestInfo = props => {
  const {
    isCreate = false,
    isEdit = false,
    rfqCategories,
    members,
    goaWorkFlow,
    valueForm,
    stampDutyOptions
  } = props

  React.useEffect(() => {
    if (stampDutyOptions.loading === false && stampDutyOptions.data.length === 0) {
      props.getStampDutyOptions()
    }
  }, [])

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard
          title='Request Information'
          accessoriesHeader={
            (isCreate)&&
            <React.Fragment>
              <ApproversE
                loading={goaWorkFlow.loading}
                approvers={goaWorkFlow.data}
              />
              {valueForm&&valueForm.urlPrintFormPo&&
              <Button 
              basic  
              circular 
              type='button' 
              content='View PO form' 
              labelPosition='right'
              onClick={()=>(window.open(valueForm.urlPrintFormPo,'_blank'))}
              icon='clipboard list' />}
            </React.Fragment>
          }
        >
          <RFQContainer>
            <div className='rowFields'>
              <Field
                name='title'
                label='Title (Request for)'
                type={type.text}
                component={FieldInput}
                editable={((isCreate || isEdit)||((valueForm&&valueForm.status===3)&&(valueForm&&valueForm.sn!==null)))}
                require
                maxLength={200}
                maxLengthMessage='Title must be less than or equal to 200 characters'
                tooltip={!isCreate && !isEdit}
              />
              <Field
                name='requesterUser'
                label='Requester'
                require
                editable={isCreate || isEdit}
                component={FieldInput}
                allowAdditions={false}
                loading={members.loading}
                options={members.map((m,i) => ({
                  key:i,
                  value: lower(m.username),
                  text: `${m.firstnameEn} ${m.lastnameEn}`,
                }))}
                type={type.select}
                
              />
            </div>
            <div className='rowFields'>
              <Field
                name='category'
                label='Category'
                require
                allowAdditions={false}
                loading={rfqCategories.loading}
                options={rfqCategories.data}
                type={type.select}
                editable={isCreate || isEdit}
                component={FieldInput}
              />
              <Field
                name='documentDate'
                label='Document Date'
                type={type.date}
                component={FieldInput}
                editable={isCreate || isEdit}
                dateFormat='dd MMM yyyy'
                require
              />
            </div>
            {!isCreate ? (
              <div className='rowFields'>
                <div className='rowFields'>
                  <Field
                    require
                    name='stampDutyType'
                    label='Type Stamp Duty'
                    type={type.select}
                    options={stampDutyOptions.data}
                    component={FieldInput}
                    editable={(isCreate||isEdit)}
                  />
                </div>
                <div className='rowFields'>
                  <Field
                    name='submittedDate'
                    label='Submitted Date'
                    type={type.date}
                    editable={false}
                    component={FieldInput}
                    dateFormat='dd MMM yyyy HH:mm'
                  />
                  <Field
                    name='modifiedDate'
                    label='Modified Date'
                    type={type.date}
                    editable={false}
                    dateFormat='dd MMM yyyy HH:mm'  
                    component={FieldInput}
                  />
                </div>
              </div>
            ) : null}
          </RFQContainer>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
    rfqCategories: state.rfq.rfqCategories,
    goaWorkFlow: state.rfq.goaWorkFlow,
    members: state.member.members,
    valueForm: getFormValues('formRFQ')(state),
    stampDutyOptions: state.options.stampDuty,
  }
}

const mapDispatchToProps = {
  getStampDutyOptions
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInfo)
